import { useAppDispatch, useAppSelector } from '~system/store/configure-store';
import { selectActiveDrawers } from '~system/store/drawer/drawer-selectors';
import {
  openSpecificDrawer as openSpecificDrawerAction,
  closeSpecificDrawer as closeSpecificDrawerAction,
  closeAllDrawers as closeAllDrawersAction,
  SpecificDrawerType,
} from '~system/store/drawer/drawer-slice';

import { DRAWERS } from '~components/shared/drawer/constants';

export const useSpecificDrawer = <T>(drawerId?: keyof typeof DRAWERS) => {
  const dispatch = useAppDispatch();
  const activeDrawers = useAppSelector(selectActiveDrawers);
  const specificDrawer = activeDrawers.find(
    (drawer) => drawer.drawerId === drawerId
  ) as SpecificDrawerType<T>;

  const openSpecificDrawer = ({ ...props }: SpecificDrawerType<T>) => {
    dispatch(openSpecificDrawerAction(props));
  };

  const closeAllDrawers = () => {
    dispatch(closeAllDrawersAction());
  };

  const closeSpecificDrawer = (id: string) => {
    dispatch(closeSpecificDrawerAction(id));
  };

  return {
    activeDrawers,
    specificDrawer,
    openSpecificDrawer,
    closeSpecificDrawer,
    closeAllDrawers,
  };
};
